export default __webpack_public_path__ + "static/media/profile.99bf1b65.png";